import { Injectable } from '@angular/core';
import { delay, Observable, of } from 'rxjs';
import { fillArr } from '@pin-up-global/common';
import { ApiService, ListResponse } from '@shared/abstraction';
import { manageLoadingStatus } from '@shared/rxjs-operators';
import { BotPlatform } from './platforms.abstraction';

@Injectable()
export class PlatformsApiServiceMock extends ApiService {
  isLoading$ = this._isLoading$;

  getPlatforms(): Observable<ListResponse<BotPlatform>> {
    return of({
      items: fillArr(5, id =>
        ({
          value: `platform_${ id }`,
          label: `Platform ${ id }`,
        }),
      ),
      count: 5,
    }).pipe(
      delay(1000),
      manageLoadingStatus(this._isLoadingMap, this._isLoadingMap$),
    );
  }
}
